<!-- Leave Conformation pop up -->
<div class="dialog-container">
    <h2 class="dialog-title">Are you sure you want to leave the session?</h2>
    <p class="dialog-subtitle">
        You haven’t joined the call yet, but leaving now means you won’t meet your {{isMentor ? "mentor" : "mentee"}}.
    </p>

    <div class="dialog-illustration">
        <img src="../../../../assets/img/IntroSlide3.jpg" alt="Illustration" />
    </div>

    <p class="dialog-help">
        <strong>Need help?</strong> Check out the video FAQs in your project materials,
        or reach out to us via the support team chat.
    </p>

    <div class="dialog-actions">
        <button mat-raised-button color="warn" (click)="closeDialog()">Leave</button>
        <button mat-raised-button color="primary" style="background-color: green; color: white;"
            (click)="stay()">Stay</button>
    </div>
</div>